module.exports = __webpack_public_path__ + "static/media/Header-background@2x.50425cc6.png";